import React, { Component } from "react";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import NativeSelect from "@material-ui/core/NativeSelect";
import Input from "@material-ui/core/Input";
import InfoIcon from "@material-ui/icons/InfoOutlined";
import Tooltip from "@material-ui/core/Tooltip";
import { getErrorString } from "../display/ErrorStrings";
import { withStyles } from "@material-ui/core/styles";
import { withTranslation } from "react-i18next";
import PopupMessage from "../components/PopupMessage";

import SaveIcon from "@material-ui/icons/SaveOutlined";
import SummaryViewIcon from "@material-ui/icons/ExpandLessOutlined";

import CircularProgress from "@material-ui/core/CircularProgress";

import CustomPaginatorActions from "../components/CustomPaginatorActions";
import TablePagination from "@material-ui/core/TablePagination";
import { ROWS_PER_PAGE_OPTIONS } from "../components/Constants";

const styles = (theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
  },
  spacer: {
    flex: "1 1 100%",
  },

  table: {
    border: "1px solid black",
    margin: "20px",
    width: 700,
  },
  progress: {
    margin: theme.spacing.unit,
  },
  paper: {
    height: 600,
    width: "100%",
    marginTop: theme.spacing.unit * 3,
    overflow: "auto",
  },
});

class HomePageAchExpanded extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorString: "",
      saveErrorString: "",
      achAccounts: [],
      noExceptions: false,
      notes: "",
      saving: false,
      loading: false,
      viewPopup: false,
      totalCount: 0,
      page: 0,
      rowsPerPage: window.sco_large_items_per_page,
    };
    this.onClosePopup = this.onClosePopup.bind(this);
  }

  onClosePopup(e) {
    this.setState({ saveErrorString: "" });
  }

  componentDidMount() {
    this.setState({ noExceptions: false });
    this.setState({ loading: true });
    this.search(this.state.page, this.state.rowsPerPage);
  }

  handleChangeRowsPerPage(e) {
    this.setState({ rowsPerPage: e.target.value });
    this.setState({ page: 0 });
    window.sco_large_items_per_page = e.target.value;
    this.search(0, e.target.value);
  }

  handleChangePage = (event, page) => {
    this.setState({ page: page });
    this.search(page, this.state.rowsPerPage);
  };

  search(page, rowsPerPage) {
    var accountsList = {};
    accountsList.secureToken = this.props.secureToken;
    accountsList.accountsData = this.props.accounts;
    accountsList.page = page;
    accountsList.rowsPerPage = rowsPerPage;
    fetch("on_ach_exception_expanded_home_page_search", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(accountsList),
    })
      .then(function (res) {
        if (!res.ok) {
          throw Error(res.status + " (" + res.statusText + ")");
        }
        return res;
      })
      .then((res) => res.text())
      .then((text) => {
        var reply = JSON.parse(text);
        if (reply.authenticated === false) {
          this.props.history.push("/expired");
        } else if (reply.error) {
          this.setState({ errorString: reply.errorString });
        } else {
          this.setState({ achAccounts: reply.accounts });
          if (reply.accounts.length === 0) {
            this.setState({ noExceptions: true });
          }
          this.setState({ totalCount: reply.totalCount });
        }
        this.setState({ loading: false });
      })
      .catch((error) => {
        this.setState({
          errorString:
            getErrorString(
              "general.server.status.error",
              "The server responded with a status of "
            ) + error.message,
        });
        this.setState({ loading: false });
      });
  }

  handleSummaryView(evenr) {
    this.props.onClose();
  }

  handleNotes(e) {
    this.setState({ notes: e.target.value });
  }

  handleSave(e) {
    if (this.props.viewOnly) {
      this.setState({
        errorString: getErrorString(
          "viewOnly.warning",
          "Operation not allowed in support mode."
        ),
      });
      this.setState({ viewPopup: true });
      return;
    }
    let accounts = this.state.achAccounts;
    let saveEmpty = true;
    let i;
    let j;
    for (i = 0; i < accounts.length; i++) {
      for (j = 0; j < accounts[i].items.length; j++) {
        if (
          accounts[i].items[j].status === "P" ||
          accounts[i].items[j].status === "R"
        ) {
          saveEmpty = false;
          break;
        }
      }
    }
    if (saveEmpty) {
      this.setState({ saveErrorString: "Nothing to save" });
      return;
    }
    this.setState({ saving: true });
    fetch("on_save_extended_ach_exception", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        accounts: this.state.achAccounts,
        comments: this.state.notes,
        secureToken: this.props.secureToken,
      }),
    })
      .then(function (res) {
        if (!res.ok) {
          throw Error(res.status + " (" + res.statusText + ")");
        }
        return res;
      })
      .then((res) => res.text())
      .then((text) => {
        var reply = JSON.parse(text);
        if (!reply.authenticated) {
          this.props.history.push("/expired");
        } else {
          this.setState({ saving: false });
          this.componentDidMount();
          if (reply.error) {
            this.setState({ saveErrorString: reply.errorString });
          }
        }
      })
      .catch((error) => {
        this.setState({
          errorString:
            getErrorString(
              "general.server.status.error",
              "The server responded with a status of "
            ) + error.message,
        });
        this.setState({ saving: false });
      });
  }

  handleAction(e, item) {
    item.status = e.target.value;
  }

  render() {
    const { classes } = this.props;
    let achAccounts = this.state.achAccounts;
    let { t } = this.props;
    const { rowsPerPage, page, totalCount } = this.state;
    return (
      <div>
        <div>
          {this.state.saveErrorString.length > 0 && (
            <PopupMessage
              title={getErrorString("general.error", "Error")}
              text={this.state.saveErrorString}
              error={true}
              onClosePopup={this.onClosePopup}
            />
          )}
          {this.state.errorString.length > 0 && (
            <div>
              <h3 style={{ color: "red" }}>{this.state.errorString} </h3>
              <Button
                color="primary"
                onClick={(event) => this.handleSummaryView(event)}
              >
                {t("backToSummary.button")}
              </Button>
            </div>
          )}
          {this.state.noExceptions && !this.state.loading && (
            <h3 style={{ color: "primary" }}>
              &nbsp;&nbsp;{t("noItemFound.label")}{" "}
            </h3>
          )}
          {this.state.achAccounts.length === 0 &&
            this.state.errorString.length === 0 &&
            this.state.loading && (
              <div>
                <br></br>
                <CircularProgress className={classes.progress} />
              </div>
            )}
          {this.state.errorString.length === 0 &&
            !this.state.loading &&
            !this.state.noExceptions && (
              <div>
                {this.state.achAccounts.length > 0 && (
                  <div style={{ margin: 20 }}>
                    <Typography variant="h6" color="primary">
                      {t("achExceptions.label")}
                      <Tooltip
                        classes={{ tooltip: classes.customWidth }}
                        title={<div>{t("snapshot.tip")}</div>}
                      >
                        <InfoIcon color="primary" />
                      </Tooltip>{" "}
                      &nbsp;&nbsp;
                      <Button
                        color="primary"
                        style={{ position: "absolute", right: 20 }}
                        onClick={(event) => this.handleSummaryView(event)}
                      >
                        <SummaryViewIcon />
                        &nbsp;{t("summaryView.button")}
                      </Button>
                    </Typography>
                    <Typography color="primary" variant="body1">
                      {" "}
                      {t("selectPayReturnAction.label")}
                    </Typography>
                    <div style={{ marginBottom: 10 }}>
                      <TextField
                        margin="dense"
                        id="notes"
                        label={t("notes.label")}
                        type="text"
                        onChange={(event) => this.handleNotes(event)}
                      />
                      &nbsp;&nbsp;
                      <Button
                        color="primary"
                        onClick={(event) => this.handleSave(event)}
                        disabled={this.state.saving}
                      >
                        <SaveIcon />
                        &nbsp;{t("saveChanges.button")}
                      </Button>
                    </div>
                    <div>
                      <div style={{ margin: 20 }}>
                        <Paper className={classes.paper}>
                          <TablePagination
                            component="div"
                            count={totalCount}
                            rowsPerPage={rowsPerPage}
                            rowsPerPageOptions={ROWS_PER_PAGE_OPTIONS}
                            page={page}
                            onChangePage={this.handleChangePage}
                            onChangeRowsPerPage={(event) =>
                              this.handleChangeRowsPerPage(event)
                            }
                            ActionsComponent={CustomPaginatorActions}
                          />
                          <Table stickyHeader>
                            <TableHead>
                              <TableRow>
                                <TableCell style={{ width: "8%" }}>
                                  <Typography
                                    variant="subtitle1"
                                    color="primary"
                                  >
                                    {t("date.header")}
                                  </Typography>
                                </TableCell>
                                <TableCell style={{ width: "14%" }}>
                                  <Typography
                                    variant="subtitle1"
                                    color="primary"
                                  >
                                    {t("trace.header")}
                                  </Typography>
                                </TableCell>
                                <TableCell style={{ width: "10%" }}>
                                  <Typography
                                    variant="subtitle1"
                                    color="primary"
                                  >
                                    {t("checkNum.header")}
                                  </Typography>
                                </TableCell>
                                <TableCell style={{ width: "6%" }}>
                                  <Typography
                                    variant="subtitle1"
                                    color="primary"
                                  >
                                    {t("code.label")}
                                  </Typography>
                                </TableCell>
                                <TableCell style={{ width: "6%" }}>
                                  <Typography
                                    variant="subtitle1"
                                    color="primary"
                                  >
                                    {t("type.label")}
                                  </Typography>
                                </TableCell>
                                <TableCell style={{ width: "6%" }}>
                                  <Typography
                                    variant="subtitle1"
                                    color="primary"
                                  >
                                    {t("crDr.header")}
                                  </Typography>
                                </TableCell>
                                <TableCell style={{ width: "10%" }}>
                                  <Typography
                                    variant="subtitle1"
                                    color="primary"
                                  >
                                    {t("serialNum.header")}
                                  </Typography>
                                </TableCell>
                                <TableCell style={{ width: "12%" }}>
                                  {t("amount.header")}
                                </TableCell>
                                <TableCell style={{ width: "15%" }}>
                                  <Typography
                                    variant="subtitle1"
                                    color="primary"
                                  >
                                    {t("action.header")}
                                  </Typography>
                                </TableCell>

                                <TableCell style={{ width: "13%" }}>
                                  <Typography
                                    variant="subtitle1"
                                    color="primary"
                                  >
                                    {t("more.header")}
                                  </Typography>
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            {achAccounts.map((account) => {
                              return (
                                <TableBody>
                                  <TableRow key={account.index}>
                                    <TableCell colSpan={11}>
                                      <Typography
                                        variant="body1"
                                        color="primary"
                                      >
                                        {t("transitEmpty.label") +
                                          account.transit +
                                          "  /  " +
                                          t("accountEmpty.label") +
                                          account.account}
                                      </Typography>
                                    </TableCell>
                                  </TableRow>

                                  {account.items.map((item) => {
                                    return (
                                      <TableRow key={item.index}>
                                        <TableCell style={{ width: "8%" }}>
                                          {item.date}
                                        </TableCell>
                                        <TableCell style={{ width: "14%" }}>
                                          {item.trace}
                                        </TableCell>
                                        <TableCell style={{ width: "10%" }}>
                                          {" "}
                                          {item.checkNumber}
                                        </TableCell>
                                        <TableCell style={{ width: "6%" }}>
                                          {item.code}
                                        </TableCell>
                                        <TableCell style={{ width: "6%" }}>
                                          {item.type}
                                        </TableCell>
                                        <TableCell style={{ width: "6%" }}>
                                          {item.crDr}
                                        </TableCell>
                                        <TableCell style={{ width: "10%" }}>
                                          {item.transSerial}
                                        </TableCell>
                                        <TableCell style={{ width: "12%" }}>
                                          {item.amount}
                                        </TableCell>
                                        <TableCell style={{ width: "15%" }}>
                                          <NativeSelect
                                            style={{
                                              height: 32,
                                              verticalAlign: "textTop",
                                              margin: 5,
                                            }}
                                            defaultValue={item.status}
                                            input={<Input id="action_type" />}
                                            onChange={(event) =>
                                              this.handleAction(event, item)
                                            }
                                          >
                                            <option value="N">
                                              {t("none.label")}
                                            </option>
                                            <option value="P">
                                              {t("pay.label")}
                                            </option>
                                            <option value="R">
                                              {t("return.label")}
                                            </option>
                                          </NativeSelect>
                                        </TableCell>

                                        <Tooltip
                                          classes={{
                                            tooltip: classes.customWidth,
                                          }}
                                          title={
                                            <div>
                                              {t("orig.label")}:{" "}
                                              {item.originator} <br />
                                              {t("companyName.header")}:{" "}
                                              {item.compName} <br />
                                              {t("compId.label")}: {item.compId}{" "}
                                              <br />
                                              {t("description.header")}:{" "}
                                              {item.compDescr} <br />
                                              {t("payInfo.label")}:{" "}
                                              {item.payInfo} <br />
                                              {t("notes.label")}: {item.notes}
                                              {item.locked && (
                                                <div>
                                                  {t("lockedBy.label")}:{" "}
                                                  {item.lockedBy}
                                                </div>
                                              )}
                                            </div>
                                          }
                                        >
                                          <TableCell style={{ width: "13%" }}>
                                            <InfoIcon color="primary" />
                                          </TableCell>
                                        </Tooltip>
                                      </TableRow>
                                    );
                                  })}
                                </TableBody>
                              );
                            })}
                          </Table>
                        </Paper>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )}
        </div>
      </div>
    );
  }
}

export default withTranslation()(withStyles(styles)(HomePageAchExpanded));
